import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
// import { TreeviewItem } from 'ngx-treeview';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AllowedItem } from 'src/app/Modules/settings/models/informate/allowed-item';
import { AllowedItemType } from 'src/app/Modules/settings/models/informate/allowed-item-type';
import { AllowedItems } from 'src/app/Modules/settings/models/informate/allowed-items';
import { InstanceDataService } from 'src/app/services/instance-data.service';

@Component({
    selector: 'app-instance-configuration-sidebar',
    templateUrl: './instance-configuration-sidebar.component.html',
    styleUrls: ['./instance-configuration-sidebar.component.scss'],
    standalone: false
})
export class InstanceConfigurationSidebarComponent implements OnInit, OnDestroy {
    @Input()
    set allowedItem(value: AllowedItems) {
        if (value !== null && value !== undefined) {
            this._allowedItem = value;
            this.cd.markForCheck();
        }
    }
    get allowedItem(): AllowedItems {
        return this._allowedItem;
    }

    @Output() allowedItemType: EventEmitter<string> = new EventEmitter();
    @Output() clickItem = new EventEmitter<AllowedItem>();

    layer: number;
    items: any[];
    values: string[];
    FirstChild: AllowedItemType;
    Secondchild: AllowedItemType;
    Thirdchild: AllowedItemType;
    forthChild: AllowedItemType;
    _allowedItem: AllowedItems;
    destroy$ = new Subject();

    constructor(
        private cd: ChangeDetectorRef,
        private instanceDataService: InstanceDataService
    ) {}

    ngOnInit(): void {
        this.instanceDataService.selectedAllowedItems.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            if (res) {
                this.loadDataBySelected(res);
            }
        });
        this.instanceDataService.selectedBreadcrumbAllowedItems.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            if (res) {
                this.loadDataAfterrefresh(res);
            }
        });
    }

    selectedItemlevelHandler(event) {
        this.instanceDataService.currentLayer.next(event.level + 1);
        this.clickItem.emit(event.item);
        switch (event.level) {
            case 1:
                this.Secondchild = event.item;
                this.Thirdchild = null;
                this.forthChild = null;
                break;
            case 2:
                this.forthChild = null;
                this.Thirdchild = event.item;
                break;
            case 3:
                this.forthChild = event.item;
                break;
        }
    }

    itemSelected(item) {
        this.Secondchild = null;
        this.Thirdchild = null;
        this.FirstChild = this.allowedItem.allowedItemTypes.find((x) => x.allowedItemTypeId == item.allowedItemTypeId);
        this.instanceDataService.currentLayer.next(1);
        this.allowedItemType.emit(item.allowedItemTypeId);
    }

    areAllItemsNested(selectedItemToDisplay): boolean {
        return selectedItemToDisplay?.items && selectedItemToDisplay.length > 0 && selectedItemToDisplay.items.every((x) => !!x && !!x.items);
    }

    loadDataBySelected(allowedItem) {
        let layer = this.instanceDataService.currentLayer.getValue();
        if (layer == 1) {
            this.Secondchild = allowedItem;
            this.Thirdchild = null;
            this.forthChild = null;
            this.instanceDataService.currentLayer.next(2);
        }
        if (layer == 2) {
            this.forthChild = null;
            this.Thirdchild = allowedItem;
            this.instanceDataService.currentLayer.next(3);
        }
        if (layer == 3) {
            this.forthChild = allowedItem;
            this.instanceDataService.currentLayer.next(4);
        }
        this.clickItem.emit(allowedItem);
    }

    loadDataAfterrefresh(itemId?: string) {
        let layer = this.instanceDataService.currentLayer.getValue();
        if (layer == 1) {
            this.Secondchild = null;
            this.Thirdchild = null;
            this.FirstChild = this.allowedItem.allowedItemTypes.find((x) => x.allowedItemTypeId == itemId);
            this.allowedItemType.emit(this.FirstChild.allowedItemTypeId);
            this.instanceDataService.currentLayer.next(1);
        }
        if (layer == 2) {
            let allowedItem = this.FirstChild.items.find((x) => x.itemId == itemId);
            this.forthChild = null;
            this.Thirdchild = allowedItem;
            this.clickItem.emit(allowedItem);
            this.instanceDataService.currentLayer.next(2);
        }
        if (layer == 3) {
            let allowedItem = this.Secondchild?.items.find((x) => x.itemId == itemId);
            this.forthChild = allowedItem;
            this.clickItem.emit(allowedItem);
            this.instanceDataService.currentLayer.next(3);
        }
    }

    ngOnDestroy() {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
